import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled, AppText, ButtonRow, Button } from '@streem/ui-react';
import { CameraSubject } from 'streem-sdk-protobuf';
import { CameraRequestState } from '../video_frame';
// Given a *current* camera subject, return the best text description to use
// for the camera subject they're *going to flip to*.
const flipToCameraText = (cameraSubject) => {
    switch (cameraSubject) {
        case CameraSubject.CAMERA_SUBJECT_PERSON:
            return 'rear-facing';
        case CameraSubject.CAMERA_SUBJECT_WORLD:
        default:
            return 'front-facing';
    }
};
export const CameraRequestPrompt = ({ cameraSubject, }) => {
    return (_jsxs(LargeWrapper, { "data-testid": "camera-request-prompt", children: [_jsx(RequestHeader, { as: "p", color: "dark", size: "medium", bold: true, headingFontFamily: true, children: "Request to Flip Camera" }), _jsxs(AppText, { as: "p", color: "dark", size: "small", children: ["This will ask the customer to start the ", flipToCameraText(cameraSubject), " view."] })] }));
};
export const CameraRequestPending = () => {
    return (_jsx(RequestPending, { color: "dark", size: "small", as: "p", children: "Requested to Flip Camera" }));
};
export const CameraRequestDeniedOrAborted = ({ requestState, onRequest, onCancel, }) => {
    const isDenied = requestState === CameraRequestState.REQUEST_DENIED;
    return (_jsxs(LargeWrapper, { "data-testid": `camera-request-${isDenied ? 'denied' : 'aborted'}-prompt`, children: [_jsx(DeniedHeader, { as: "p", color: "dark", size: "medium", bold: true, headingFontFamily: true, children: isDenied ? 'Camera Flip Denied' : 'Camera Flip Error' }), _jsx(DeniedBody, { as: "p", color: "dark", size: "small", children: isDenied
                    ? 'Your request to flip camera was denied.'
                    : 'There was an error attempting to flip the camera. Please try again.' }), _jsxs(TooltipButtonRow, { children: [_jsx(Button, { variant: "tertiary", onClick: onCancel, fontSize: "small", children: "Cancel" }), _jsx(Button, { variant: "tertiary", onClick: onRequest, fontSize: "small", "data-testid": `camera-request-${isDenied ? 'denied' : 'aborted'}-request-again-button`, children: "Request Again" })] })] }));
};
const DeniedHeader = styled(AppText) `
    padding-bottom: 2px;
`;
const DeniedBody = styled(AppText) `
    padding-bottom: 6px;
`;
const RequestHeader = styled(AppText) `
    padding-bottom: 4px;
`;
const RequestPending = styled(AppText) `
    width: 150px;
    padding: 6px;
`;
const TooltipButtonRow = styled(ButtonRow)({
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '0.25rem',
    '>*:not(:last-of-type)': {
        marginRight: 0,
    },
});
const LargeWrapper = styled.div `
    width: 210px;
    padding-left: 6px;
    padding-right: 6px;
    padding-bottom: 7px;
    padding-top: 4px;
`;
//# sourceMappingURL=camera_request_messages.js.map